import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { VideoProvider } from '@statsbomb/video-client-js';
import ApolloClientProvider from './apollo/ApolloClientProvider';
import Auth0ProviderWithHistory from './apollo/Auth0ProviderWithHistory';
import App from './components/app';
import './styles/index.scss';
import { AccountConfigProvider } from './utils/providers/AccountConfigProvider';
import { UserConfigProvider } from './utils/providers/UserConfigProvider';

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <VideoProvider baseUrlVideoApp={process.env.VIDEO_APP_BASE_URL}>
    <BrowserRouter>
      <Auth0ProviderWithHistory
        domain={process.env.REACT_APP_DOMAIN}
        clientId={process.env.REACT_APP_CLIENT_ID}
        audience={process.env.REACT_APP_AUDIENCE}
      >
        <ApolloClientProvider apiUri={process.env.REACT_APP_API_URI}>
          <UserConfigProvider>
            <AccountConfigProvider>
              <App />
            </AccountConfigProvider>
          </UserConfigProvider>
        </ApolloClientProvider>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </VideoProvider>
);
